import {
  Avatar,
  Checkbox,
  CircularProgress,
  Grid,
  LinearProgress,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import Button from '../../components/atoms/button';
import CustomSelect from '../../components/atoms/custom-select';
import FileUpload from '../../components/atoms/file-upload';
import InputTextAreaField from '../../components/atoms/input-field/inputTextAreaField';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import Popup from '../../components/atoms/popup';
import Toast, {
  showToasterFailure,
  showToasterSuccess,
} from '../../components/atoms/toast';
import { APIHeader, APIHeaderForUpload } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  LocalSiteButtons,
  LocalSiteComment,
  LocalSiteDropdown,
  ReviewDoneMessage,
  SiteReviewTitle,
  SiteReviewValue,
  TextAsLink,
  UploadedDocument,
  boldFont,
  buttonCircularProgress,
  buttonDiv,
  checkboxGrid,
  checkboxLabel,
  commentStyle,
  homeButtonComponent,
  lscDescriptionValue,
  noFileUploaded,
  popupInfoGrid,
  popupInformationGrid,
  progressBar,
  reviewPageDropdown,
  reviewPageLabel,
  selectAll,
  titleName,
  uploadedFilesGrid,
  validationError,
  validationErrorOnPages,
} from '../../styles';
import {
  duplicates,
  findUnique,
  keyMapper,
  isEmptyObject,
  removeDuplicates,
  stripTrailingSlash,
  getURL,
  getDownloadLink,
  validateInputFields,
} from '../../utils';

/*********Component for Site P/ECR Owner Review************/
const SiteOwner = props => {
  const { apiConfig, userInfo, errorInAPI } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [siteData, setSiteData] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [showProgress, setShowProgress] = useState(false);
  const [comment, setComment] = useState('');
  const [departmentData, setDepartmentData] = useState([]);
  const [checkboxSelected, setCheckboxSelected] = useState([]);
  const [checkboxOptions, setCheckboxOptions] = useState([]);
  const [checkboxItems, setCheckboxItems] = useState([]);
  const [singleAvatar, setSingleAvatar] = useState([]);
  const [multipleAvatar, setMultipleAvatar] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [displayFiles, setDisplayFiles] = useState([]);
  const [defaultPopupData, setDefaultPopupData] = useState([]);
  const [popupData, setPopupData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openPopup, setOpenPopup] = useState({
    open: false,
    option: '',
    departmentId: -1,
    departmentName: '',
  });
  const [toggleSavePopupClick, setToggleSavePopupClick] = useState(null);
  const [inputValidationMessage, setInputValidationMessage] = useState('');
  const [showSaveProgress, setShowSaveProgress] = useState(false);
  const [docUploadedByCraetor, setDocUploadedByCraetor] = useState([]);
  const [docUploadedBySC, setDocUploadedBySC] = useState([]);

  const color = ['#07417b', '#0d6efd', '#818589', '#C7CED6'];

  const urlInfo = stripTrailingSlash(window.location.toString()).split('/');
  const siteId = urlInfo.pop();
  const pecrId = urlInfo.pop();
  const url = getURL();
  const departmentRef = useRef();

  useEffect(() => {
    if (pecrId && siteId) {
      //Fetching the details for SiteOwner page
      fetch(`${apiConfig.uiURL}api/SiteOwner`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          pecrId: pecrId,
          siteId: siteId,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setSiteData(data);
          if (
            data.length > 0 &&
            (data[0].SOStatusId === null || data[0].SOStatusId === '5') &&
            data[0].StatusID === '8'
          ) {
            setDisabled(false);
          } else {
            setDisabled(true);
          }
          if (data.length > 0) {
            //set already submitted comments
            setComment(data[0].Comments);
            //Fetch Files from Folder
            fetch(`${apiConfig.uiURL}api/FetchFilesFromOwner`, {
              method: 'POST',
              headers: APIHeader(),
              body: JSON.stringify({
                MainFolder: 'PECROverview',
                SubFolder: pecrId,
                siteId: siteId,
                owner: 'Owner',
              }),
            })
              .then(async response => {
                const files = await response.json();
                setDisplayFiles(files);
              })
              .catch(() => {
                dispatch(
                  errorNotification({
                    hasErrorOccured: true,
                    message: t('error_message'),
                  })
                );
              });
          }
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pecrId, siteId, apiConfig]);

  useEffect(() => {
    if (pecrId) {
      //To fetch the files uploaded by Creator on Overview page
      fetch(`${apiConfig.uiURL}api/FetchFiles`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          MainFolder: 'PECROverview',
          SubFolder: pecrId,
        }),
      })
        .then(async response => {
          const files = await response.json();
          const filterFilesOnly = files.filter(file => {
            return file.includes('.');
          });
          setDocUploadedByCraetor(filterFilesOnly);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });

      //Fetch Files from Folder uploaded by Site Coordinator
      fetch(`${apiConfig.uiURL}api/FetchFilesFromSiteReview`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          MainFolder: 'PECROverview',
          SubFolder: pecrId,
          siteId: siteId,
          siteReview: 'SiteReview',
        }),
      })
        .then(async response => {
          const files = await response.json();
          setDocUploadedBySC(files);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pecrId, siteId, apiConfig]);

  //Fetching department details
  const SCDepartmentsAPICall = () => {
    fetch(`${apiConfig.uiURL}api/SCDepartments`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        SiteId: siteId,
        pecrId: pecrId,
      }),
    })
      .then(async response => {
        const data = await response.json();
        const filterWithName = [];
        data.length > 0 &&
          data.forEach(deptInfo => {
            if (
              deptInfo.Department === 'Quality' ||
              deptInfo.Department === 'Engineering' ||
              deptInfo.Department === 'Manufacturing' ||
              deptInfo.Department === 'Sales' ||
              deptInfo.Department === 'Logistics / Supply Chain' ||
              deptInfo.Department === 'Industrial Process'
            ) {
              if (deptInfo.FirstName && deptInfo.LastName) {
                filterWithName.push(deptInfo);
              }
            } else {
              filterWithName.push(deptInfo);
            }
          });

        setDepartmentData(data);
        setCheckboxOptions([]);
        const uniqueData = findUnique(filterWithName, key => key.Department);
        uniqueData.forEach(value => {
          setCheckboxOptions(prevState => [
            ...prevState,
            {
              Department: value.Department,
              DepartmentID: value.DepartmentID,
              FirstName: value.FirstName,
              LastName: value.LastName,
              DepartmentOwnerEmail: value.Email,
              DepartmentOwnerID: value.ID,
              EIndex: value.EIndex,
            },
          ]);
        });

        setSingleAvatar(removeDuplicates(data, key => key.Department));
        setMultipleAvatar(duplicates(data, key => key.Department));

        //To get the list of department to show with checkboxes on UI
        if (data && data.length > 0) {
          setCheckboxItems([]);
          const checkboxData = findUnique(data, key => key.Department);
          checkboxData.forEach(value => {
            setCheckboxItems(prevState => [
              ...prevState,
              {
                Department: value.Department,
                DepartmentID: value.DepartmentID,
                FirstName: value.FirstName,
                LastName: value.LastName,
              },
            ]);
          });
        }

        //To check the checkboxes those are selected on site coordinator review page (OR) To check the checkboxes selected by Owner once review is done
        let splitString = [];
        if (disabled) {
          splitString =
            siteData.length > 0 &&
            siteData[0].SOSelected &&
            siteData[0].SOSelected.split(',').map(item => +item);
        } else {
          splitString =
            siteData.length > 0 &&
            siteData[0].SCSelected &&
            siteData[0].SCSelected.split(',').map(item => +item);
        }
        if (splitString && splitString.length > 0) {
          const SCcheckboxSelected = data.filter(item => {
            return splitString.includes(item.DepartmentID);
          });
          const filterSCSelectedWithName = [];
          SCcheckboxSelected.length > 0 &&
            SCcheckboxSelected.forEach(deptInfo => {
              if (
                deptInfo.Department === 'Quality' ||
                deptInfo.Department === 'Engineering' ||
                deptInfo.Department === 'Manufacturing' ||
                deptInfo.Department === 'Sales' ||
                deptInfo.Department === 'Logistics / Supply Chain' ||
                deptInfo.Department === 'Industrial Process'
              ) {
                if (deptInfo.FirstName && deptInfo.LastName) {
                  filterSCSelectedWithName.push(deptInfo);
                }
              } else {
                filterSCSelectedWithName.push(deptInfo);
              }
            });
          const uniqueArray = findUnique(
            filterSCSelectedWithName,
            key => key.Department
          ).map(item => {
            return {
              Department: item.Department,
              DepartmentID: item.DepartmentID,
              FirstName: item.FirstName,
              LastName: item.LastName,
              DepartmentOwnerEmail: item.Email,
              DepartmentOwnerID: item.ID,
              EIndex: item.EIndex,
            };
          });
          if (toggleSavePopupClick === null) {
            return (
              setCheckboxSelected(uniqueArray),
              setToggleSavePopupClick(!toggleSavePopupClick)
            );
          } else {
            setCheckboxSelected(checkboxSelected);
          }
        }
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  useEffect(() => {
    SCDepartmentsAPICall();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteData]);

  //To handle the comment onChange
  const commentOnChange = event => {
    const eventValue = event.target.value.trim();
    setComment(eventValue);
    const ValidationMessage = validateInputFields(eventValue, t);
    setInputValidationMessage(ValidationMessage);
  };

  //To check whether all checkboxes are checked or not
  const isAllSelected =
    checkboxOptions.length > 0 &&
    checkboxSelected.length ===
      checkboxOptions.filter(value => value.FirstName && value.LastName).length;

  //To open the department's popup according to the department
  const handlePopupOpen = (event, option) => {
    fetch(`${apiConfig.uiURL}api/SCDepartmentsPOPUP`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        pecrId: pecrId,
        SiteId: siteId,
        DepartmentID: option.DepartmentID,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setPopupData(data);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    fetch(`${apiConfig.uiURL}api/SCDefaultDepartmentsPOPUP`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        SiteId: siteId,
        pecrId: pecrId,
        DepartmentName: option.Department,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setDefaultPopupData(data);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    departmentRef.current = option.Department;
    setOpenPopup({
      open: true,
      option: option.Department,
      departmentId: option.DepartmentID,
      departmentName: option.Department,
    });
  };

  //To close the department's popup
  const handlePopupClose = () => {
    setOpenPopup({
      open: false,
      option: '',
      departmentId: -1,
      departmentName: '',
    });
  };

  //To handle the onChange of checkbox
  const handleCheckboxChange = (event, option) => {
    const value = event.target.value;
    if (value === 'all') {
      const filteredCheckboxOptions = checkboxOptions.filter(
        value => value.FirstName && value.LastName
      );
      setCheckboxSelected(
        checkboxSelected.length === filteredCheckboxOptions.length
          ? []
          : filteredCheckboxOptions.map(item => {
              return {
                Department: item.Department,
                DepartmentID: item.DepartmentID,
                FirstName: item.FirstName,
                LastName: item.LastName,
                DepartmentOwnerEmail: item.Email,
                DepartmentOwnerID: item.ID,
                EIndex: item.EIndex,
              };
            })
      );
      return;
    }
    // added below code to update checkboxSelected options
    const list = [...checkboxSelected];
    const index = list.map(item => item.Department).indexOf(option.Department);
    index === -1 ? list.push(option) : list.splice(index, 1);
    const filteredCheckboxOptions = checkboxOptions.filter(
      value => value.FirstName && value.LastName
    );
    const filteredList = filteredCheckboxOptions.filter(elem =>
      list.find(({ Department }) => elem.Department === Department)
    );
    setCheckboxSelected(filteredList);
  };

  //suppose department is checked and by department popup if User is removing
  //all multiple/single Department head then that department will be unselected on its own.
  //When department owner is selected or modified for Department then the Department checkbox will be selected on its own.
  useEffect(() => {
    const filteredCheckboxOptions = checkboxOptions.filter(
      value => value.FirstName && value.LastName
    );
    const filteredDept =
      filteredCheckboxOptions.find(
        ({ Department }) => departmentRef.current === Department
      ) || {};

    const list = [...checkboxSelected];
    const index = list
      .map(item => item.Department)
      .indexOf(departmentRef.current);
    index === -1 || !isEmptyObject(filteredDept)
      ? list.push(filteredDept)
      : list.splice(index, 1);
    const filteredList = filteredCheckboxOptions.filter(elem =>
      list.find(({ Department }) => elem.Department === Department)
    );
    setCheckboxSelected(filteredList);
    departmentRef.current = '';
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxOptions, toggleSavePopupClick]);

  const listItem = checkboxItems.map(option => {
    const checked =
      checkboxSelected.length > 0 &&
      checkboxSelected.some(list => {
        return list.Department === option.Department;
      });
    return (
      <Grid key={option.DepartmentID} style={checkboxLabel}>
        <Grid>
          <Checkbox
            value={option.Department}
            onChange={event => handleCheckboxChange(event, option)}
            checked={checked}
            disabled={disabled}
          />
        </Grid>
        <Grid
          sx={{
            position: 'relative',
            top: 10,
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Typography
            onClick={event => {
              handlePopupOpen(event, option);
            }}
            sx={{
              cursor: !disabled ? 'pointer' : 'default',
            }}
          >
            {option.Department}
          </Typography>
          {[
            'Quality',
            'Engineering',
            'Manufacturing',
            'Sales',
            'Logistics / Supply Chain',
            'Industrial Process',
          ].some(item => item === option.Department)
            ? multipleAvatar.length > 0 &&
              multipleAvatar.map((item, index) => {
                const displayName = `${item.FirstName}${item.LastName}`;
                return item.Department === option.Department &&
                  item.FirstName &&
                  item.LastName ? (
                  <Avatar
                    sx={{
                      bgcolor: color[index % 4],
                      width: 28,
                      height: 28,
                      fontSize: 13,
                      marginLeft: 0.6,
                    }}
                    key={index}
                  >
                    {displayName}
                  </Avatar>
                ) : null;
              })
            : singleAvatar.length > 0 &&
              singleAvatar.map((singleData, index) => {
                const displayName = `${singleData.FirstName}${singleData.LastName}`;
                return singleData.Department === option.Department &&
                  singleData.FirstName &&
                  singleData.LastName ? (
                  <Avatar
                    sx={{
                      bgcolor: '#07417b',
                      width: 24,
                      height: 24,
                      fontSize: 13,
                      marginLeft: 0.6,
                    }}
                    key={index}
                  >
                    {displayName}
                  </Avatar>
                ) : null;
              })}
        </Grid>
      </Grid>
    );
  });

  // to handle the deletion of uploaded document
  const removeDoc = (event, fileName) => {
    event.preventDefault();
    const remainingFile = displayFiles.filter(file => {
      return file !== fileName;
    });
    setDisplayFiles(remainingFile);
    const remainingUploadFile = uploadedFiles.filter(file => {
      return file.name !== fileName;
    });
    setUploadedFiles(remainingUploadFile);
    fetch(`${apiConfig.uiURL}api/DeleteFile`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        fileName: fileName,
        PID: pecrId,
        folderName: 'SiteOwner',
        email: userInfo.userEmail,
        phase: 'Owner',
      }),
    }).catch(() => {
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    });
    setErrorMessage('');
  };

  //To handle the onClick event of Hold button
  // const onHoldClick = () => {
  //   //To update the status of P/ECR
  //   fetch(`${apiConfig.uiURL}api/PECRStatusUpdate`, {
  //     headers: APIHeader(),
  //     method: "PUT",
  //     body: JSON.stringify({
  //       StatusID: 9,
  //       pecrId: pecrId,
  //       PlantsImpacted: siteId,
  //       updateAction: "SOHold",
  //       Comments: comment,
  //       LSCUserId: userInfo.userID,
  //       OwnerId: (siteData.length > 0 && siteData[0].OwnerID) || "",
  //     }),
  //   })
  //     .then(async (response) => {
  //       //To send the mail to the P/ECR creator when P/ECR is on hold
  //       fetch(`${apiConfig.uiURL}api/sendEmail`, {
  //         headers: APIHeader(),
  //         method: "POST",
  //         body: JSON.stringify({
  //           PecrId: pecrId,
  //           toAddress: (siteData.length > 0 && siteData[0].Email) || "",
  //           loginUserEmail: userInfo.userEmail,
  //           Title: (siteData.length > 0 && siteData[0].Title) || "",
  //           Description: (siteData.length > 0 && siteData[0].Description) || "",
  //           fromAddress: "PECR@carrier.com",
  //           type: "assignEmail",
  //           URL: "",
  //           Factory: (siteData.length > 0 && siteData[0].SiteName) || "",
  //           Strategic: "",
  //           EHSI: "",
  //           RI: "",
  //           ECI: "",
  //           TA: "",
  //           WCI: "",
  //           PPS: "",
  //           toWhome: "Site Owner Hold",
  //           Comments: comment,
  //           creatorsite:
  //             (siteData.length > 0 && siteData[0].CreatorSiteName) || "",
  //           creator:
  //             (siteData.length > 0 &&
  //               `${siteData[0].CreatorFirstName} ${siteData[0].CreatorLastName}`) ||
  //             "",
  //         }),
  //       }).catch(() => {
  //         dispatch(
  //           errorNotification({
  //             hasErrorOccured: true,
  //             message: t("error_message"),
  //           })
  //         );
  //       });
  //     })
  //     .catch(() => {
  //       dispatch(
  //         errorNotification({
  //           hasErrorOccured: true,
  //           message: t("error_message"),
  //         })
  //       );
  //     });

  //   //navigate to list page
  //   navigate("../List");
  // };

  //To handle the onClick event of Not Impacted button
  const onNotImpactedClick = () => {
    fetch(`${apiConfig.uiURL}api/soDecision`, {
      headers: APIHeader(),
      method: 'POST',
      body: JSON.stringify({
        statusId: 11,
        pecrId: pecrId,
        siteImpacted: siteId,
        updateAction: 'SONotImpacted',
        comments: comment,
        lscId: userInfo.userID,
        ownerId: (siteData.length > 0 && siteData[0].OwnerID) || '',
      }),
    })
      .then(async response => {
        //To send the mail to the P/ECR creator
        fetch(`${apiConfig.uiURL}api/sendEmail`, {
          headers: APIHeader(),
          method: 'POST',
          body: JSON.stringify({
            PecrId: pecrId,
            toAddress: (siteData.length > 0 && siteData[0].Email) || '',
            loginUserEmail: userInfo.userEmail,
            Title: (siteData.length > 0 && siteData[0].Title) || '',
            Description: (siteData.length > 0 && siteData[0].Description) || '',
            fromAddress: 'PECR@carrier.com',
            type: 'assignEmail',
            URL: '',
            Factory: (siteData.length > 0 && siteData[0].SiteName) || '',
            Strategic: '',
            EHSI: '',
            RI: '',
            ECI: '',
            TA: '',
            WCI: '',
            PPS: '',
            toWhome: 'Site Owner Not Impacted',
            Comments: comment ? comment : '',
            creatorsite:
              (siteData.length > 0 && siteData[0].CreatorSiteName) || '',
            creator:
              (siteData.length > 0 &&
                `${siteData[0].CreatorFirstName} ${siteData[0].CreatorLastName}`) ||
              '',
          }),
        }).catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
        //navigate to list page
        navigate('../List');
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To check whether department has owner or not
  const hasDepartmentOwner =
    checkboxSelected.length > 0 &&
    checkboxSelected.every(item => {
      return item.FirstName && item.LastName;
    });

  //To upload the files in folder
  const fileUpload = (isApproveButtonClicked = false) => {
    //To upload the files in folder of Site Owner
    const uploadData = new FormData();
    for (const file of uploadedFiles) {
      uploadData.append('file', file);
    }
    uploadData.append('MainFolder', 'PECROverview');
    uploadData.append('SubFolder', pecrId);
    uploadData.append('siteId', siteId);
    uploadData.append('owner', 'Owner');

    // API call to upload the document
    fetch(`${apiConfig.uiURL}api/uploadDocForOwner`, {
      headers: APIHeaderForUpload(),
      method: 'POST',
      body: uploadData,
    })
      .then(async res => {
        if (res.status === 200) {
          //stop showing progress bar
          setShowProgress(false);
          setShowSaveProgress(false);
          //navigate to List page if Approve button clicked
          isApproveButtonClicked && navigate('../List');
        }
      })
      .catch(() => {
        setShowProgress(false);
        setShowSaveProgress(false);
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To handle the onClick of Save button
  const onSaveClick = () => {
    setShowSaveProgress(true);
    /********To get the details of selected department owner*********/
    const SelectedDepartmentOwnerDetail = [];
    if (hasDepartmentOwner) {
      departmentData.map(
        item =>
          checkboxSelected.length > 0 &&
          checkboxSelected.map(value => {
            if (
              value.DepartmentID === item.DepartmentID &&
              item.ID &&
              item.Email
            ) {
              SelectedDepartmentOwnerDetail.push({
                departmentName: item.Department,
                email: item.Email,
                departmentId: item.DepartmentID,
                departmentOwnerId: item.ID,
                EIndex: item.EIndex,
              });
              return SelectedDepartmentOwnerDetail;
            }
            return SelectedDepartmentOwnerDetail;
          })
      );
    }

    //Update the data using PECRStatusUpdate API
    const updateData = fetch(`${apiConfig.uiURL}api/soDecision`, {
      headers: APIHeader(),
      method: 'POST',
      body: JSON.stringify({
        statusId: '',
        pecrId: pecrId,
        siteImpacted: siteId,
        updateAction: 'SOApprove',
        comments: comment,
        lscId: userInfo.userID,
        ownerId: (siteData.length > 0 && siteData[0].OwnerID) || '',
        selectedDepartments:
          checkboxSelected.length > 0 &&
          keyMapper(checkboxSelected, 'DepartmentID').toString(),
        selectedDepartmentsOwnerId:
          SelectedDepartmentOwnerDetail.length > 0 &&
          keyMapper(
            SelectedDepartmentOwnerDetail,
            'departmentOwnerId'
          ).toString(),
      }),
    }).then(() => {
      //call fileUpload function to upload the file
      fileUpload();
    });
    Promise.all([updateData])
      .then(() => {
        showToasterSuccess(t('Save_message'));
      })
      .catch(() => {
        showToasterFailure(t('Save_failed_message'));
      });
  };

  //To handle the onClick event of Approve for Owner Review button
  const onApproveClick = () => {
    setShowProgress(true);
    /********To get the details of selected department owner*********/
    const SelectedDepartmentOwnerDetail = [];
    if (hasDepartmentOwner) {
      departmentData.map(
        item =>
          checkboxSelected.length > 0 &&
          checkboxSelected.map(value => {
            if (
              value.DepartmentID === item.DepartmentID &&
              item.ID &&
              item.Email
            ) {
              SelectedDepartmentOwnerDetail.push({
                departmentName: item.Department,
                email: item.Email,
                departmentId: item.DepartmentID,
                departmentOwnerId: item.ID,
                EIndex: item.EIndex,
              });
              return SelectedDepartmentOwnerDetail;
            }
            return SelectedDepartmentOwnerDetail;
          })
      );
    }

    //To update the status of P/ECR
    fetch(`${apiConfig.uiURL}api/soDecision`, {
      headers: APIHeader(),
      method: 'POST',
      body: JSON.stringify({
        statusId: 4,
        pecrId: pecrId,
        siteImpacted: siteId,
        updateAction: 'SOApprove',
        comments: comment,
        lscId: userInfo.userID,
        ownerId: (siteData.length > 0 && siteData[0].OwnerID) || '',
        selectedDepartments:
          checkboxSelected.length > 0 &&
          keyMapper(checkboxSelected, 'DepartmentID').toString(),
        selectedDepartmentsOwnerId:
          SelectedDepartmentOwnerDetail.length > 0 &&
          keyMapper(
            SelectedDepartmentOwnerDetail,
            'departmentOwnerId'
          ).toString(),
      }),
    })
      .then(async response => {
        //call fileUpload function to upload the file
        fileUpload(true);

        //To send the mail to selected departments owners with the URL
        SelectedDepartmentOwnerDetail.forEach(item => {
          return (
            fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                PecrId: pecrId,
                toAddress: item.email,
                loginUserEmail: userInfo.userEmail,
                Title: (siteData.length > 0 && siteData[0].Title) || '',
                Description:
                  (siteData.length > 0 && siteData[0].Description) || '',
                fromAddress: 'PECR@carrier.com',
                type: 'assignEmail',
                URL: `${url}Department/${pecrId}/${siteId}/${item.departmentId}/${item.EIndex}`,
                Factory: (siteData.length > 0 && siteData[0].SiteName) || '',
                Strategic: '',
                EHSI: '',
                RI: '',
                ECI: '',
                TA: '',
                WCI: '',
                PPS: '',
                toWhome: 'Site Department Owner',
                Comments: comment ? comment : '',
                Departments: item.departmentName,
                creatorsite:
                  (siteData.length > 0 && siteData[0].CreatorSiteName) || '',
                creator:
                  (siteData.length > 0 &&
                    `${siteData[0].CreatorFirstName} ${siteData[0].CreatorLastName}`) ||
                  '',
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            fetch(`${apiConfig.uiURL}api/InsertDifferentDepartments`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                pecrId: pecrId,
                siteId: siteId,
                departmentId: item.departmentId,
                EIndex: item.EIndex,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            fetch(`${apiConfig.uiURL}api/CreateFolderBasedOnDepartment`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                MainFolder: 'PECROverview',
                pecrId: pecrId,
                siteId: siteId,
                departmentId: item.departmentId,
                index: item.EIndex,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            })
          );
        });
      })
      .catch(() => {
        setShowProgress(false);
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });

    //To send the mail to the P/ECR creator when P/ECR is approved with selected departments
    fetch(`${apiConfig.uiURL}api/sendEmail`, {
      headers: APIHeader(),
      method: 'POST',
      body: JSON.stringify({
        PecrId: pecrId,
        toAddress: (siteData.length > 0 && siteData[0].Email) || '',
        loginUserEmail: userInfo.userEmail,
        Title: (siteData.length > 0 && siteData[0].Title) || '',
        Description: (siteData.length > 0 && siteData[0].Description) || '',
        fromAddress: 'PECR@carrier.com',
        type: 'assignEmail',
        Factory: (siteData.length > 0 && siteData[0].SiteName) || '',
        Strategic: '',
        EHSI: '',
        RI: '',
        ECI: '',
        TA: '',
        WCI: '',
        PPS: '',
        toWhome: 'Site Owner Submit',
        Comments: comment,
        Departments:
          checkboxSelected.length > 0 &&
          keyMapper(checkboxSelected, 'Department').toString(),
        creatorsite: (siteData.length > 0 && siteData[0].CreatorSiteName) || '',
        creator:
          (siteData.length > 0 &&
            `${siteData[0].CreatorFirstName} ${siteData[0].CreatorLastName}`) ||
          '',
      }),
    }).catch(() => {
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    });
  };

  const MultipleValuePopup = ({ defaultPopupData, popupData }) => {
    const label1 =
      popupData.length > 0
        ? popupData[0].Quality1Label ||
          popupData[0].Manufacturing1Label ||
          popupData[0].Engineering1Label ||
          popupData[0].Sales1Label ||
          popupData[0].IndustrialProcess1Label ||
          popupData[0].LogisticsSupplyChain1Label
        : '';
    const label2 =
      popupData.length > 0
        ? popupData[0].Quality2Label ||
          popupData[0].Manufacturing2Label ||
          popupData[0].Engineering2Label ||
          popupData[0].Sales2Label ||
          popupData[0].IndustrialProcess2Label ||
          popupData[0].LogisticsSupplyChain2Label
        : '';
    const label3 =
      popupData.length > 0
        ? popupData[0].Quality3Label ||
          popupData[0].Manufacturing3Label ||
          popupData[0].Engineering3Label ||
          popupData[0].Sales3Label ||
          popupData[0].IndustrialProcess3Label ||
          popupData[0].LogisticsSupplyChain3Label
        : '';
    const label4 =
      popupData.length > 0
        ? popupData[0].Quality4Label ||
          popupData[0].Manufacturing4Label ||
          popupData[0].Engineering4Label ||
          popupData[0].Sales4Label ||
          popupData[0].IndustrialProcess4Label ||
          popupData[0].LogisticsSupplyChain4Label
        : '';

    const defaultName =
      defaultPopupData.length > 0 &&
      defaultPopupData.map(item => {
        return {
          label:
            item.FirstName && item.LastName
              ? `${item.FirstName} ${item.LastName}`
              : null,
          value: item.ID,
        };
      });

    const options =
      popupData.length > 0 &&
      popupData.map(list => {
        return {
          label: `${list.FirstName} ${list.LastName}`,
          value: list.UserId,
        };
      });

    const [optionChange, setOptionChange] = useState({
      owner1: defaultName[0] ? defaultName[0] : null,
      owner2: defaultName[1] ? defaultName[1] : null,
      owner3: defaultName[2] ? defaultName[2] : null,
      owner4: defaultName[3] ? defaultName[3] : null,
    });

    const [labelChange, setLabelChange] = useState({
      label1: label1,
      label2: label2,
      label3: label3,
      label4: label4,
    });
    const [labelValidationMessage, setLabelValidationMessage] = useState({
      label1: '',
      label2: '',
      label3: '',
      label4: '',
    });

    const hasNotValidationError =
      labelValidationMessage.label1 === '' &&
      labelValidationMessage.label2 === '' &&
      labelValidationMessage.label3 === '' &&
      labelValidationMessage.label4 === '';

    const apiBody = () => {
      if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        return {
          Engineering1Label: (labelChange && labelChange.label1) || null,
          Engineering2Label: (labelChange && labelChange.label2) || null,
          Engineering3Label: (labelChange && labelChange.label3) || null,
          Engineering4Label: (labelChange && labelChange.label4) || null,
          Engineering1OwnerID:
            (optionChange &&
              optionChange.owner1 &&
              optionChange.owner1.value) ||
            null,
          Engineering2OwnerID:
            (optionChange &&
              optionChange.owner2 &&
              optionChange.owner2.value) ||
            null,
          Engineering3OwnerID:
            (optionChange &&
              optionChange.owner3 &&
              optionChange.owner3.value) ||
            null,
          Engineering4OwnerID:
            (optionChange &&
              optionChange.owner4 &&
              optionChange.owner4.value) ||
            null,
        };
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        return {
          Manufacturing1Label: (labelChange && labelChange.label1) || null,
          Manufacturing2Label: (labelChange && labelChange.label2) || null,
          Manufacturing3Label: (labelChange && labelChange.label3) || null,
          Manufacturing4Label: (labelChange && labelChange.label4) || null,
          Manufacturing1OwnersID:
            (optionChange &&
              optionChange.owner1 &&
              optionChange.owner1.value) ||
            null,
          Manufacturing2OwnerID:
            (optionChange &&
              optionChange.owner2 &&
              optionChange.owner2.value) ||
            null,
          Manufacturing3OwnerID:
            (optionChange &&
              optionChange.owner3 &&
              optionChange.owner3.value) ||
            null,
          Manufacturing4OwnerID:
            (optionChange &&
              optionChange.owner4 &&
              optionChange.owner4.value) ||
            null,
        };
      } else if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        return {
          Quality1Label: (labelChange && labelChange.label1) || null,
          Quality2Label: (labelChange && labelChange.label2) || null,
          Quality3Label: (labelChange && labelChange.label3) || null,
          Quality4Label: (labelChange && labelChange.label4) || null,
          Quality1OwnerID:
            (optionChange &&
              optionChange.owner1 &&
              optionChange.owner1.value) ||
            null,
          Quality2OwnerID:
            (optionChange &&
              optionChange.owner2 &&
              optionChange.owner2.value) ||
            null,
          Quality3OwnerID:
            (optionChange &&
              optionChange.owner3 &&
              optionChange.owner3.value) ||
            null,
          Quality4OwnerID:
            (optionChange &&
              optionChange.owner4 &&
              optionChange.owner4.value) ||
            null,
        };
      } else if (popupData.length > 0 && popupData[0].Name === 'Sales') {
        return {
          Sales1Label: (labelChange && labelChange.label1) || null,
          Sales2Label: (labelChange && labelChange.label2) || null,
          Sales3Label: (labelChange && labelChange.label3) || null,
          Sales4Label: (labelChange && labelChange.label4) || null,
          Sales1OwnerID:
            (optionChange &&
              optionChange.owner1 &&
              optionChange.owner1.value) ||
            null,
          Sales2OwnerID:
            (optionChange &&
              optionChange.owner2 &&
              optionChange.owner2.value) ||
            null,
          Sales3OwnerID:
            (optionChange &&
              optionChange.owner3 &&
              optionChange.owner3.value) ||
            null,
          Sales4OwnerID:
            (optionChange &&
              optionChange.owner4 &&
              optionChange.owner4.value) ||
            null,
        };
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Industrial Process'
      ) {
        return {
          IndustrialProcess1Label: (labelChange && labelChange.label1) || null,
          IndustrialProcess2Label: (labelChange && labelChange.label2) || null,
          IndustrialProcess3Label: (labelChange && labelChange.label3) || null,
          IndustrialProcess4Label: (labelChange && labelChange.label4) || null,
          IndustrialProcessOwnerID:
            (optionChange &&
              optionChange.owner1 &&
              optionChange.owner1.value) ||
            null,
          IndustrialProcess2OwnerID:
            (optionChange &&
              optionChange.owner2 &&
              optionChange.owner2.value) ||
            null,
          IndustrialProcess3OwnerID:
            (optionChange &&
              optionChange.owner3 &&
              optionChange.owner3.value) ||
            null,
          IndustrialProcess4OwnerID:
            (optionChange &&
              optionChange.owner4 &&
              optionChange.owner4.value) ||
            null,
        };
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Logistics / Supply Chain'
      ) {
        return {
          LogisticsSupplyChain1Label:
            (labelChange && labelChange.label1) || null,
          LogisticsSupplyChain2Label:
            (labelChange && labelChange.label2) || null,
          LogisticsSupplyChain3Label:
            (labelChange && labelChange.label3) || null,
          LogisticsSupplyChain4Label:
            (labelChange && labelChange.label4) || null,
          LogisticsSupplyChainOwnerID:
            (optionChange &&
              optionChange.owner1 &&
              optionChange.owner1.value) ||
            null,
          LogisticsSupplyChain2OwnerID:
            (optionChange &&
              optionChange.owner2 &&
              optionChange.owner2.value) ||
            null,
          LogisticsSupplyChain3OwnerID:
            (optionChange &&
              optionChange.owner3 &&
              optionChange.owner3.value) ||
            null,
          LogisticsSupplyChain4OwnerID:
            (optionChange &&
              optionChange.owner4 &&
              optionChange.owner4.value) ||
            null,
        };
      }
    };

    const [apiData, setApiData] = useState(
      popupData.length > 0 && defaultPopupData.length > 0 && apiBody()
    );

    const handleChange1 = option => {
      setOptionChange({ ...optionChange, owner1: option });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality1OwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering1OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing1OwnersID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Sales') {
        setApiData({
          ...apiData,
          Sales1OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Industrial Process'
      ) {
        setApiData({
          ...apiData,
          IndustrialProcessOwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Logistics / Supply Chain'
      ) {
        setApiData({
          ...apiData,
          LogisticsSupplyChainOwnerID: option ? option.value : '',
        });
      }
    };
    const handleChange2 = option => {
      setOptionChange({ ...optionChange, owner2: option });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality2OwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering2OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing2OwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Sales') {
        setApiData({
          ...apiData,
          Sales2OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Industrial Process'
      ) {
        setApiData({
          ...apiData,
          IndustrialProcess2OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Logistics / Supply Chain'
      ) {
        setApiData({
          ...apiData,
          LogisticsSupplyChain2OwnerID: option ? option.value : '',
        });
      }
    };
    const handleChange3 = option => {
      setOptionChange({ ...optionChange, owner3: option });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality3OwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering3OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing3OwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Sales') {
        setApiData({
          ...apiData,
          Sales3OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Industrial Process'
      ) {
        setApiData({
          ...apiData,
          IndustrialProcess3OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Logistics / Supply Chain'
      ) {
        setApiData({
          ...apiData,
          LogisticsSupplyChain3OwnerID: option ? option.value : '',
        });
      }
    };
    const handleChange4 = option => {
      setOptionChange({ ...optionChange, owner4: option });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality4OwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering4OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing4OwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Sales') {
        setApiData({
          ...apiData,
          Sales4OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Industrial Process'
      ) {
        setApiData({
          ...apiData,
          IndustrialProcess4OwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Logistics / Supply Chain'
      ) {
        setApiData({
          ...apiData,
          LogisticsSupplyChain4OwnerID: option ? option.value : '',
        });
      }
    };
    const labelOnChange1 = event => {
      const updatedLabel = event.target.value.trim();
      setLabelChange({ ...labelChange, label1: updatedLabel });
      const ValidationMessage = validateInputFields(updatedLabel, t);
      setLabelValidationMessage({
        ...labelValidationMessage,
        label1: ValidationMessage,
      });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality1Label: updatedLabel,
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering1Label: updatedLabel,
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing1Label: updatedLabel,
        });
      }
    };
    const labelOnChange2 = event => {
      const updatedLabel = event.target.value.trim();
      setLabelChange({ ...labelChange, label2: updatedLabel });
      const ValidationMessage = validateInputFields(updatedLabel, t);
      setLabelValidationMessage({
        ...labelValidationMessage,
        label2: ValidationMessage,
      });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality2Label: updatedLabel,
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering2Label: updatedLabel,
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing2Label: updatedLabel,
        });
      }
    };
    const labelOnChange3 = event => {
      const updatedLabel = event.target.value.trim();
      setLabelChange({ ...labelChange, label3: updatedLabel });
      const ValidationMessage = validateInputFields(updatedLabel, t);
      setLabelValidationMessage({
        ...labelValidationMessage,
        label3: ValidationMessage,
      });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality3Label: updatedLabel,
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering3Label: updatedLabel,
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing3Label: updatedLabel,
        });
      }
    };
    const labelOnChange4 = event => {
      const updatedLabel = event.target.value.trim();
      setLabelChange({ ...labelChange, label4: updatedLabel });
      const ValidationMessage = validateInputFields(updatedLabel, t);
      setLabelValidationMessage({
        ...labelValidationMessage,
        label4: ValidationMessage,
      });
      if (popupData.length > 0 && popupData[0].Name === 'Quality') {
        setApiData({
          ...apiData,
          Quality4Label: updatedLabel,
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Engineering') {
        setApiData({
          ...apiData,
          Engineering4Label: updatedLabel,
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Manufacturing'
      ) {
        setApiData({
          ...apiData,
          Manufacturing4Label: updatedLabel,
        });
      }
    };

    //To update the data for Departments' popup
    const onPopupSaveClick = () => {
      fetch(`${apiConfig.uiURL}api/SCDepartmentsPOPUPUpdate`, {
        headers: APIHeader(),
        method: 'PUT',
        body: JSON.stringify({
          ...apiData,
          pecrId: pecrId,
          SiteID: siteId,
          DepartmentID: openPopup.departmentId,
        }),
      })
        .then(async response => {
          SCDepartmentsAPICall();
          handlePopupClose();
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    };

    return (
      <Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Label')} 1:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <InputTextField
              name={'DepartmentLabel1'}
              placeholder={t('Enter_Department_One_Label')}
              value={labelChange.label1}
              onChange={event => labelOnChange1(event)}
            />
            <Grid style={validationError}>{labelValidationMessage.label1}</Grid>
          </Grid>
        </Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Owner')} 1:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <CustomSelect
              name={'departmentowner1'}
              id={'departmentowner1'}
              placeholder={t('Select_Department_One_Owner')}
              options={options.length > 0 ? options : []}
              onChange={handleChange1}
              value={
                optionChange &&
                optionChange.owner1 &&
                optionChange.owner1.label !== null
                  ? optionChange.owner1
                  : ''
              }
              isClearable={true}
            />
          </Grid>
        </Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Label')} 2:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <InputTextField
              name={'DepartmentLabel2'}
              placeholder={t('Enter_Department_Two_Label')}
              value={labelChange.label2}
              onChange={event => labelOnChange2(event)}
            />
            <Grid style={validationError}>{labelValidationMessage.label2}</Grid>
          </Grid>
        </Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Owner')} 2:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <CustomSelect
              name={'departmentowner2'}
              id={'departmentowner2'}
              placeholder={t('Select_Department_Two_Owner')}
              options={options.length > 0 ? options : []}
              onChange={handleChange2}
              value={
                optionChange &&
                optionChange.owner2 &&
                optionChange.owner2.label !== null
                  ? optionChange.owner2
                  : ''
              }
              isClearable={true}
            />
          </Grid>
        </Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Label')} 3:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <InputTextField
              name={'DepartmentLabel3'}
              placeholder={t('Enter_Department_Three_Label')}
              value={labelChange.label3}
              onChange={event => labelOnChange3(event)}
            />
            <Grid style={validationError}>{labelValidationMessage.label3}</Grid>
          </Grid>
        </Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Owner')} 3:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <CustomSelect
              name={'departmentowner3'}
              id={'departmentowner3'}
              placeholder={t('Select_Department_Three_Owner')}
              options={options.length > 0 ? options : []}
              onChange={handleChange3}
              value={
                optionChange &&
                optionChange.owner3 &&
                optionChange.owner3.label !== null
                  ? optionChange.owner3
                  : ''
              }
              menuPlacement={'top'}
              isClearable={true}
            />
          </Grid>
        </Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Label')} 4:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <InputTextField
              name={'DepartmentLabel4'}
              placeholder={t('Enter_Department_Four_Label')}
              value={labelChange.label4}
              onChange={event => labelOnChange4(event)}
            />
            <Grid style={validationError}>{labelValidationMessage.label4}</Grid>
          </Grid>
        </Grid>
        <Grid style={popupInfoGrid}>
          <Grid style={reviewPageLabel}>{`${t('Owner')} 4:`}</Grid>
          <Grid style={reviewPageDropdown}>
            <CustomSelect
              name={'departmentowner4'}
              id={'departmentowner4'}
              placeholder={t('Select_Department_Four_Owner')}
              options={options.length > 0 ? options : []}
              onChange={handleChange4}
              value={
                optionChange &&
                optionChange.owner4 &&
                optionChange.owner4.label !== null
                  ? optionChange.owner4
                  : ''
              }
              menuPlacement={'top'}
              isClearable={true}
            />
          </Grid>
        </Grid>
        <Grid style={buttonDiv}>
          <Button title={t('Cancel')} onClick={handlePopupClose} />
          <Button
            title={t('Save')}
            onClick={onPopupSaveClick}
            disabled={!hasNotValidationError}
          />
        </Grid>
      </Grid>
    );
  };

  const SingleValuePopup = ({ defaultPopupData, popupData }) => {
    const defaultName = defaultPopupData?.map(item => {
      return { label: `${item.FirstName} ${item.LastName}`, value: item.ID };
    });

    const options = popupData?.map(list => {
      return { label: `${list.FirstName} ${list.LastName}`, value: list.ID };
    });
    const [optionChange, setOptionChange] = useState(defaultName);
    const [apiData, setApiData] = useState({});

    const handleChange = option => {
      setOptionChange(option);
      if (popupData.length > 0 && popupData[0].Name === 'Compliance') {
        setApiData({
          ComplianceOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'EH&S') {
        setApiData({
          EHSOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Finance') {
        setApiData({
          FinanceOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Aftermarket') {
        setApiData({
          AfermarketOwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Industrial Process'
      ) {
        setApiData({
          IndustrialProcessOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Literature') {
        setApiData({
          LiteratureOwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Logistics / Supply Chain'
      ) {
        setApiData({
          LogisticsSupplyChainOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Marketing') {
        setApiData({
          MarketingOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Purchasing') {
        setApiData({
          PurchasingOwnerID: option ? option.value : '',
        });
      } else if (
        popupData.length > 0 &&
        popupData[0].Name === 'Safety Committee'
      ) {
        setApiData({
          SafetyCommitteeOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Master Data') {
        setApiData({
          MasterDataOwnerID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Sales') {
        setApiData({
          SalesID: option ? option.value : '',
        });
      } else if (popupData.length > 0 && popupData[0].Name === 'Sales Tools') {
        setApiData({
          SalesToolsOwnerID: option ? option.value : '',
        });
      }
    };

    //To update the data for Departments' popup
    const onPopupSaveClick = () => {
      if (isEmptyObject(apiData)) {
        handlePopupClose();
        setToggleSavePopupClick(!toggleSavePopupClick);
      } else {
        fetch(`${apiConfig.uiURL}api/SCDepartmentsPOPUPUpdate`, {
          headers: APIHeader(),
          method: 'PUT',
          body: JSON.stringify({
            ...apiData,
            pecrId: pecrId,
            SiteID: siteId,
            DepartmentID: openPopup.departmentId,
          }),
        })
          .then(async response => {
            SCDepartmentsAPICall();
            handlePopupClose();
          })
          .catch(() => {
            dispatch(
              errorNotification({
                hasErrorOccured: true,
                message: t('error_message'),
              })
            );
          });
      }
    };

    return (
      <Grid>
        <Grid style={popupInformationGrid}>
          <Grid style={boldFont}>{`${t('Owner')}:`}</Grid>
          <Grid style={LocalSiteDropdown}>
            <CustomSelect
              name={'departmentowner'}
              id={'departmentowner'}
              placeholder={t('Select_Department_Owner')}
              options={options.length > 0 ? options : []}
              onChange={handleChange}
              value={optionChange}
              isClearable={true}
            />
          </Grid>
        </Grid>
        <Grid style={buttonDiv}>
          <Button title={t('Cancel')} onClick={handlePopupClose} />
          <Button title={t('Save')} onClick={onPopupSaveClick} />
        </Grid>
      </Grid>
    );
  };

  //To download the file uploaded by Owner on Site Owner page
  const onDownloadFileForSiteOwnerClick = filename => {
    fetch(`${apiConfig.uiURL}api/DownloadFileForOwner`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        filename: filename,
        owner: 'Owner',
      }),
    })
      .then(async response => {
        response.blob().then(blob => {
          getDownloadLink(blob, filename);
        });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To download the file uploaded by Creator on Overview page
  const onDownloadFileFromCreatorClick = filename => {
    fetch(`${apiConfig.uiURL}api/DownloadFilesForLSC`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        filename: filename,
      }),
    })
      .then(async response => {
        response.blob().then(blob => {
          getDownloadLink(blob, filename);
        });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To download the file uploaded by Site Coordinator on Site Coordinator page
  const onDownloadFileForSiteCoordinatorClick = filename => {
    fetch(`${apiConfig.uiURL}api/DownloadFileForSiteReview`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        filename: filename,
        siteReview: 'SiteReview',
      }),
    })
      .then(async response => {
        response.blob().then(blob => {
          getDownloadLink(blob, filename);
        });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  return errorInAPI.hasErrorOccured ? (
    <ErrorAlert message={errorInAPI.message} />
  ) : siteData.length > 0 && userInfo && userInfo.userId !== '' ? (
    userInfo?.active?.toString() === '1' &&
    userInfo?.userId?.toString() !== '0' &&
    userInfo?.userId !== null &&
    Number(userInfo?.userID) === Number(siteData[0]?.OwnerID) ? (
      <Grid>
        {disabled && (
          <Grid style={ReviewDoneMessage}>
            {t('Site_Owner_has_already_reviewed_the_PECR')}
          </Grid>
        )}
        <Grid style={SiteReviewTitle}>
          <h4 style={titleName}>{t('Site_PECR_Owner_Review')}</h4>
        </Grid>
        <Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Title')}:</Grid>
            <Grid style={lscDescriptionValue}>
              {siteData.length > 0 && siteData[0].Title}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Description')}:</Grid>
            <Grid style={lscDescriptionValue}>
              {siteData.length > 0 && siteData[0].Description}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Product_Family')}:</Grid>
            <Grid style={lscDescriptionValue}>
              {siteData.length > 0 && siteData[0].ProductFamily}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Creator')}:</Grid>
            <Grid style={lscDescriptionValue}>
              {siteData.length > 0 &&
                siteData[0].CreatorFirstName &&
                siteData[0].CreatorLastName &&
                siteData[0].CreatorSiteName &&
                `${siteData[0].CreatorFirstName} ${siteData[0].CreatorLastName} (${siteData[0].CreatorSiteName})`}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Site')}:</Grid>
            <Grid style={SiteReviewValue}>
              {siteData.length > 0 && siteData[0].SiteName}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('PECR_Owner')}:</Grid>
            <Grid style={SiteReviewValue}>
              {siteData.length > 0 &&
                `${siteData[0].FirstName} ${siteData[0].LastName}`}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid>
              {t(
                'Select_departments_below_required_to_estimate_effort_and_costs'
              )}
              <Grid style={checkboxGrid}>
                <Checkbox
                  value="all"
                  onChange={event => handleCheckboxChange(event, {})}
                  checked={isAllSelected}
                  disabled={disabled}
                />
                <span style={selectAll}>{t('SELECT_ALL')}</span>
                {listItem}
              </Grid>
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={uploadedFilesGrid}>
              <Grid style={UploadedDocument}>
                {`${t('Doc_uploaded_by_Creator')}:`}
              </Grid>
              <Grid style={UploadedDocument}>
                {docUploadedByCraetor.length > 0 ? (
                  docUploadedByCraetor.map((document, index) => {
                    return (
                      <Tooltip
                        key={index}
                        title={document}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: '14px',
                            },
                          },
                        }}
                      >
                        <Typography
                          key={index}
                          noWrap
                          width={400}
                          style={TextAsLink}
                          onClick={() =>
                            onDownloadFileFromCreatorClick(document)
                          }
                        >
                          {document}
                        </Typography>
                      </Tooltip>
                    );
                  })
                ) : (
                  <Grid style={noFileUploaded}>
                    {t('No_files_have_been_uploaded')}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid style={SiteReviewTitle}>
            <Grid style={uploadedFilesGrid}>
              <Grid style={UploadedDocument}>
                {`${t('Doc_uploaded_by_SC')}:`}
              </Grid>
              <Grid style={UploadedDocument}>
                {docUploadedBySC.length > 0 ? (
                  docUploadedBySC.map((document, index) => {
                    return (
                      <Tooltip
                        key={index}
                        title={document}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: '14px',
                            },
                          },
                        }}
                      >
                        <Typography
                          key={index}
                          noWrap
                          width={400}
                          style={TextAsLink}
                          onClick={() =>
                            onDownloadFileForSiteCoordinatorClick(document)
                          }
                        >
                          {document}
                        </Typography>
                      </Tooltip>
                    );
                  })
                ) : (
                  <Grid style={noFileUploaded}>
                    {t('No_files_have_been_uploaded')}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          {disabled ? (
            <Grid style={SiteReviewTitle}>
              <Grid style={uploadedFilesGrid}>
                <Grid style={UploadedDocument}>{t('Doc_uploaded_by_SO')}:</Grid>
                <Grid style={UploadedDocument}>
                  {displayFiles && displayFiles.length > 0 ? (
                    displayFiles.map((document, index) => {
                      return (
                        <Tooltip
                          key={index}
                          title={document}
                          componentsProps={{
                            tooltip: {
                              sx: {
                                fontSize: '14px',
                              },
                            },
                          }}
                        >
                          <Typography
                            key={index}
                            noWrap
                            width={400}
                            style={TextAsLink}
                            onClick={() =>
                              onDownloadFileForSiteOwnerClick(document)
                            }
                          >
                            {document}
                          </Typography>
                        </Tooltip>
                      );
                    })
                  ) : (
                    <Grid style={noFileUploaded}>
                      {t('No_files_have_been_uploaded')}
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <FileUpload
              displayFiles={displayFiles}
              setDisplayFiles={setDisplayFiles}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              removeDoc={removeDoc}
              allowedFileNumber={10}
              disabled={disabled}
            />
          )}
          <Grid style={LocalSiteComment}>
            <InputTextAreaField
              name={'SCRComment'}
              onChange={commentOnChange}
              customStyle={commentStyle}
              placeholder={!disabled ? t('Add_Comments_here') : ''}
              disabled={disabled}
              value={comment}
            />
          </Grid>
          <Grid style={validationErrorOnPages}>{inputValidationMessage}</Grid>
        </Grid>
        <Toast />
        <Grid style={LocalSiteButtons}>
          {/* <Button title={"Hold"} onClick={onHoldClick} disabled={disabled} /> */}
          <Button
            title={t('Not_Impacted')}
            onClick={onNotImpactedClick}
            disabled={disabled || inputValidationMessage !== ''}
          />
          <Grid sx={{ position: 'relative' }}>
            <Button
              title={t('Save')}
              onClick={onSaveClick}
              disabled={
                disabled || inputValidationMessage !== '' || showSaveProgress
              }
            />
            {showSaveProgress && (
              <CircularProgress size={28} sx={buttonCircularProgress} />
            )}
          </Grid>
          <Button
            title={t('Approve_for_Estimate')}
            onClick={onApproveClick}
            disabled={
              disabled ||
              !hasDepartmentOwner ||
              checkboxSelected.length === 0 ||
              inputValidationMessage !== ''
            }
          />
        </Grid>
        {openPopup.open && !disabled && (
          <Popup
            title={siteData.length > 0 && siteData[0].Title}
            department={openPopup.departmentName}
            open={openPopup.open}
            handleClose={handlePopupClose}
          >
            {[
              'Quality',
              'Engineering',
              'Manufacturing',
              'Sales',
              'Industrial Process',
              'Logistics / Supply Chain',
            ].some(item => item === openPopup.option) ? (
              <MultipleValuePopup
                defaultPopupData={defaultPopupData}
                popupData={popupData}
              />
            ) : (
              <SingleValuePopup
                defaultPopupData={defaultPopupData}
                popupData={popupData}
              />
            )}
          </Popup>
        )}
        {showProgress && (
          <Grid style={progressBar}>
            <LinearProgress color="success" sx={{ padding: '5px' }} />
          </Grid>
        )}
      </Grid>
    ) : (
      <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
    )
  ) : (
    <Grid style={homeButtonComponent}>
      <CircularProgress />
    </Grid>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(SiteOwner);
